import e from "react";
const r = (r2) => (Array.isArray(r2) ? r2 : [r2]).map((r3, l) => e.isValidElement(r3) && null == r3.key ? e.cloneElement(r3, { key: l }) : r3);
export {
  r as withReactKeys
};
//# sourceMappingURL=withReactKeys.js.map
